import React from 'react';
import { useDispatch } from 'react-redux';
import { setSectionFormType, setSectionType } from '../../../../Features/storefrontSlice';
import CrossGray from '../../../../Assets/StorefrontIcons/CrossGray.svg';
import AboutOne from './AboutOne';
import AboutTwo from './AboutTwo';
import AboutThree from './AboutThree';
import FeaturesOne from './FeaturesOne';
import FeaturesTwo from './FeaturesTwo';

function AboutSectionOptions() {
    const dispatch = useDispatch();

    function handleClose() {
        dispatch(setSectionType(null));
        dispatch(setSectionFormType(null));
    }

    return (
        <div className='ml-0 w-[250px] h-full bg-[#FFFFFF] border-r border-[#EAEAEA] flex flex-col gap-1'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[20px] leading-6 text-[#121212] pl-3'>Add Sections</p>

                <div className="size-11 p-[10px] flex items-center justify-center">
                    <button onClick={handleClose} className='size-6 flex items-center justify-center outline-none'>
                        <img src={CrossGray} alt="" />
                    </button>
                </div>
            </div>

            <div className="h-[calc(100%-44px)] flex flex-col gap-3 px-3 overflow-y-scroll no-scrollbar pt-1 pb-3">
                <AboutOne />

                <AboutTwo />

                <AboutThree />

                <FeaturesOne />

                <FeaturesTwo />
            </div>
        </div>
    );
}

export default AboutSectionOptions;
